import axios from '@/utils/api'

const actions = {

  async saveRelDocumentoProcessoRetificacao ({ commit }, payload) {
    await axios({
      method: 'POST',
      url: `publico/relDocumentoProcessoRetificacao/saveByIdDocumentoAndIdProcesso/${payload.idDocumento}/${payload.idProcesso}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/relDocumentoProcessoRetificacao.js